// src/apolloClient.js
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { createUploadLink } from "apollo-upload-client";
import { onError } from "@apollo/client/link/error";
import { serverConfig } from "../src/config";

// Get the backend URI from environment variables
const BACKEND_URI = serverConfig.serverURI;
console.log("log 037", serverConfig);

// Create HTTP URI based on the backend URI
const HTTP_URI = `${BACKEND_URI}/graphql`;

// Create an upload link for queries and mutations
const uploadLink = createUploadLink({
  uri: HTTP_URI,
  credentials: "include", // Include credentials if needed
});

// Create an authentication link to include auth token in headers
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("accessToken");
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

// Helper function to handle permission update logout
const handlePermissionUpdateLogout = () => {
  console.log("Permissions have been updated, logging out...");

  // Clear all auth-related local storage
  localStorage.removeItem("accessToken");
  localStorage.removeItem("authToken");
  localStorage.removeItem("rbacPermissions");
  localStorage.removeItem("adminToken");
  localStorage.removeItem("adminPermissions");
  localStorage.removeItem("impersonatedUser");
  localStorage.removeItem("permissionsUpdatedAt");

  // Show a notification to the user
  alert("Your permissions have been updated. Please log in again to continue.");

  // Redirect to login page
  window.location.href = "/auth/sign-in";
};

// Add error handling link
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, extensions }) => {
      // Check for permissions updated error
      if (
        message.includes("PERMISSIONS_UPDATED") ||
        (extensions && extensions.code === "PERMISSIONS_UPDATED")
      ) {
        handlePermissionUpdateLogout();
      }
    });
  }

  if (networkError && networkError.statusCode === 401) {
    // Also handle 401 errors that might be permission related
    if (
      networkError.result &&
      networkError.result.code === "PERMISSIONS_UPDATED"
    ) {
      handlePermissionUpdateLogout();
    }
  }
});

// Combine authLink and uploadLink with error link
const httpLinkWithAuth = errorLink.concat(authLink.concat(uploadLink));

// Initialize Apollo Client
const client = new ApolloClient({
  link: httpLinkWithAuth,
  cache: new InMemoryCache(),
});

// Log connection information in development environment
if (process.env.NODE_ENV === "development") {
  console.log(`Apollo Client connecting to HTTP endpoint: ${HTTP_URI}`);
}

export default client;
